<template>
  <div class="external-invoice">
    <v-container v-if="!loaded">
      <div class="text-center">
          <div class="mb-10">
            <img src="~@images/logo.svg" class="logo" height="60">
          </div>
          <v-progress-circular
           indeterminate
           color="primary"
           size="50"
          />
      </div>
    </v-container>
    <v-container v-else-if="done">
      <div class="text-center">
        <div class="mb-10">
          <img src="~@images/logo.svg" class="logo" height="60">
        </div>
        <div class="font-weight-light" style="font-size: 20px">
          {{ $t('register-external-operator.consumption-statement-saved') }}
          <div>
            <v-icon size="60">ico-emoticon-happy</v-icon>
          </div>
          {{ $t('register-external-operator.thank-you') }}
        </div>
      </div>
    </v-container>
    <v-container v-else-if="!tokenIsValid">
      <v-row class="ma-30">
        <v-col class="text-center">
          <div class="mb-10">
            <img src="../../../assets/images/logo.svg" class="logo" height="60">
          </div>
          <div class=" red--text">
            {{ $t('register-external-operator.token-expired') }}
          </div>
          <div class="font-weight-light">
            {{ $t('register-external-operator.token-expired-2') }}
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else>
      <v-row>
        <v-col>
          <img src="~@images/logo.svg" class="logo" height="60">
        </v-col>
        <v-col class="text-right">
          <span class="title">
            {{ $t('register-external-operator.consumption-statement-entry') }}
          </span>
        </v-col>
      </v-row>


      <register-external-invoice-standard v-if="meterDeviceData.supplier === 'STANDARD'" />
      <register-external-invoice-zeplug v-if="meterDeviceData.supplier === 'ZEPLUG'"  />



    </v-container>
    <div class="car">
      <img src="@images/car.front.png" />
    </div>
  </div>
</template>

<script>
import MeterDeviceRepository from "@repository/MeterDeviceRepository";
import RegisterExternalInvoiceStandard
  from "@pages/MeterDevice/RegisterExternalInvoice/RegisterExternalInvoiceStandard.vue";
import RegisterExternalInvoiceZeplug
  from "@pages/MeterDevice/RegisterExternalInvoice/RegisterExternalInvoiceZeplug.vue";
import dayjs from "dayjs";

export default {
  components: {
    RegisterExternalInvoiceStandard,
    RegisterExternalInvoiceZeplug,
  },

  data() {
    return {
      loaded: false,
      done: false,
      meterDeviceData: null,
      tokenIsValid: false,
    }
  },

  mounted() {
    this.loadData()
  },

  watch: {

  },

  computed: {


  },

  methods: {
    loadData() {
      const token = this.$route.query.token
      if(token) {
        MeterDeviceRepository.getMeterDeviceByStatementToken(token).then(data => {
          this.loaded = true
          this.tokenIsValid = !!data
          this.meterDeviceData = data
          if(data.customer?.language) {
            dayjs.locale(data.customer.language)
            this.$i18n.locale = data.customer.language
            this.$vuetify.lang.current = data.customer.language
          }
        })
      }
    },



    save(obj, files) {

      this.showLoading(true)
      const form = this.cloneObj(obj)
      form.token = this.$route.query.token
      for(const k in form.data) {
        if(form.data[k].consumption) {
          form.data[k].consumption = form.data[k].consumption * 1000
        }
      }

      let data = new FormData()
      for(let file of files) {
        data.append('files[]', file)
      }
      data.append('data', JSON.stringify(form))

      MeterDeviceRepository.createExternalOperatorStatement(data).then(() => {
        this.notifySuccess(this.$t('register-external-operator.consumption-statement-success'))
        this.showLoading(false)
        this.done = true
      }).catch(err => {
        this.notifyError(err)
        this.showLoading(false)
      })
    }

  }
}
</script>

<style lang="scss">
.external-invoice {
  padding: 20px;
  .container {
    background: rgba(255, 255, 255, 0.75);
    border-radius: 6px;
    padding: 20px;
    .title {
      font-size: 30px !important;
      font-weight: bold;
      margin-bottom: 20px;
      color: var(--v-primary-base);
    }
    .error--text {
      .v-input__slot {
        border: 1px solid red;
      }
    }
    .v-text-field__details {
      margin-bottom: 0;
    }
    .with-field-controls {
      padding-top: 22px;
    }
    z-index: 1;
  }
  .car {
    position: fixed;
    z-index: 0;
    right: 0;
    bottom: 0;
  }
}
</style>